import { slugify } from '@sky-it-livedata-libraries/livedata-commons';
import type { ICardFootballRanking } from '@sky-it-livedata/livedata-sports-design-system';
import { DataCardRankingQuery } from '../types';
import { isValidDataCardRankingObject } from './typeguards';
import { ErrorName, WidgetError } from '../../../utils/errors';
import { CreateCardCompetitionRankingInputSchema } from 'appsync';
import { RoundName } from '@sky-it-livedata/livedata-sports-design-system/core/typings/match.js';
import { intcmpMap } from '../../../utils/intcmp';


const transformer = (obj: DataCardRankingQuery): ICardFootballRanking => {
    if (isValidDataCardRankingObject(obj)) {
        CreateCardCompetitionRankingInputSchema().parse(obj.data.getCardCompetitionRanking, {reportInput: true});

        const { createdAt, updatedAt, ...dataCardRanking } = obj.data.getCardCompetitionRanking;
        const competitionSlug = slugify(dataCardRanking!.customCompetitionName!);
        return {
            ...dataCardRanking,
            rankingLink: dataCardRanking!.rankingLink ?? undefined,
            customCompetitionName: dataCardRanking!.customCompetitionName ?? undefined,
            groups: dataCardRanking!.groups!.map((group) => ({
                roundName: group!.roundName as RoundName,
                rows: group!.teams!.map((row) => ({
                    ...row,
                    games: row!.games as number,
                    points: row!.points as number,
                    position: row!.position as number,
                    teamName: row!.teamName as string,
                    trend: row!.trend as 'up' | 'down' | 'static',
                    logoUrl: (row!.negativeLogoUrl ?? row!.logoUrl ?? '') as string,
                    targetUrl: (row!.teamUrl ?? '') as string,
                    title: `Posizione: ${row!.position}; ${row!.teamName}; Punti: ${row!.points};`,
                    trackingData: { intcmp: intcmpMap.dataCardRanking.getDetailLink(competitionSlug) },
                })),
            })),
            trackingData: { 'analytics-element': `card-ranking-football-${competitionSlug}` },
            cardCtaTrackingData: { intcmp: intcmpMap.dataCardRanking.getCtaLink(competitionSlug) },
        };
    } else {
        throw new WidgetError<ErrorName>({
            name: 'NO_VALID_DATA',
            message: 'Invalid transformer input, Error in DataCardRankingQuery object',
            data: obj
        });
    }
};

export default transformer;
